import { client } from "api";
import { Company, CompanyState } from "models/Company";

export type GetAllCompaniesRequest = { states?: CompanyState[] | null } | undefined;
export type GetAllCompaniesResponse = Company[];

export const getAllCompanies = (filters: GetAllCompaniesRequest) =>
  client.get<GetAllCompaniesResponse>(`/company/list`, {
    params: {
      states: filters?.states?.join(",")
    }
  }).then((res) => res.data);
